export const BANQUE_LESSONS_PT = [
  {
    id: 'banque-1',
    numero: 1,
    titre: "Abrir uma conta bancária",
    sousTitre: "O seu direito e as suas opções",
    contexte: "Abrir uma conta bancária em França — quais são os seus direitos e os documentos necessários?",
    explication: [
      "**Direito a uma conta bancária**: toda a pessoa residente em França tem direito a uma conta — mesmo que um banco a tenha recusado.",
      "**Droit au compte**: se um banco o recusar, dirija-se ao Banco de França. Atribuirá um banco em 24 horas.",
      "**Documentos necessários**: documento de identidade válido + comprovativo de morada com menos de 3 meses. Suficiente na maioria dos casos.",
      "**A conta básica**: serviço gratuito que inclui cartão bancário, transferências e pagamentos — disponível em todos os bancos.",
      "**Bancos electrónicos**: Nickel (nos tabacos), Revolut, Orange Bank — abrem uma conta em 5 minutos sem documentação complicada.",
    ],
    question: "Um banco recusou abrir a conta. Qual é o direito legal?",
    options: [
      { id: 'a', text: "Contactar o Banco de França que atribuirá um banco", correct: true },
      { id: 'b', text: "Não há opção — o banco é livre de recusar", correct: false },
      { id: 'c', text: "Apresentar queixa na polícia", correct: false },
    ],
    explication_reponse: "O direito à conta (Droit au compte) é garantido por lei. O Banco de França é obrigado a atribuir um banco em 24 horas. Número: 3414.",
  },
  {
    id: 'banque-2',
    numero: 2,
    titre: "Compreender o cartão bancário",
    sousTitre: "Utilizá-lo e protegê-lo",
    contexte: "O cartão bancário é uma ferramenta diária. Como usá-lo com segurança e o que fazer em caso de problema?",
    explication: [
      "**O código secreto**: nunca o dê a ninguém — nem ao banco. Não o escreva no cartão.",
      "**Pagamento sem código (sans contact)**: montantes até 50€ com um simples toque do cartão. Conveniente mas atenção se perder o cartão.",
      "**Desactivar o sans contact**: se quiser desactivá-lo, contacte o banco ou faça-o na aplicação do banco.",
      "**Em caso de perda**: ligue imediatamente para 0892 705 705 (número de bloqueio unificado em França) para bloquear o cartão.",
      "**Pagamento online**: use o cartão apenas em sites de confiança — procure o 🔒 https na barra de endereço.",
    ],
    question: "Qual o número a ligar imediatamente em caso de perda do cartão bancário?",
    options: [
      { id: 'a', text: "0892 705 705", correct: true },
      { id: 'b', text: "3414", correct: false },
      { id: 'c', text: "36 46", correct: false },
    ],
    explication_reponse: "0892 705 705 é o número de bloqueio de cartão unificado em França — funciona 24/24, 7/7. Pode também bloquear directamente na aplicação do banco.",
  },
  {
    id: 'banque-3',
    numero: 3,
    titre: "Gerir a conta correctamente",
    sousTitre: "Evitar descobertos e taxas",
    contexte: "A conta está baixa e o mês não acabou. Como evitar as taxas e os descobertos?",
    explication: [
      "**Monitorizar o saldo**: verifique o saldo semanalmente na aplicação do banco — sem surpresas.",
      "**O descoberto (découvert)**: se a conta permitir descoberto, as taxas começam imediatamente. Informe o banco se tiver dificuldades.",
      "**Pagamento recusado**: as taxas por pagamento recusado chegam a 30€. Evite-o cancelando uma transferência automática que não pode cobrir.",
      "**Taxas da conta**: verifique o contrato — algumas contas são gratuitas, outras têm taxas mensais. Compare e mude se necessário.",
      "**Microcrédito**: se tiver dificuldades financeiras, Adie.org oferece pequenos empréstimos a pessoas recusadas pelos bancos.",
    ],
    question: "Como evitar taxas por pagamento recusado?",
    options: [
      { id: 'a', text: "Cancelar qualquer transferência automática que não consegue cobrir antes da data", correct: true },
      { id: 'b', text: "Não é possível controlar isso", correct: false },
      { id: 'c', text: "Pagar taxas de descoberto antecipadas ao banco", correct: false },
    ],
    explication_reponse: "Pode cancelar qualquer transferência automática (seguro, renda...) na aplicação do banco com 5 dias de antecedência. Evita as taxas quando o saldo é insuficiente.",
  },
  {
    id: 'banque-4',
    numero: 4,
    titre: "Transferências e empréstimos",
    sousTitre: "Como lidar com o banco",
    contexte: "Quer enviar dinheiro ou pedir um empréstimo. O que saber para evitar erros e taxas desnecessárias.",
    explication: [
      "**Transferência SEPA**: entre contas europeias — gratuito na maioria dos bancos, chega num dia útil.",
      "**RIB**: necessário para qualquer transferência ou pagamento — contém IBAN e BIC. Obtenha-o na aplicação ou no balcão do banco.",
      "**Empréstimo ao consumidor**: antes de assinar, verifique o TAEG (Taxa Anual de Encargos Efectiva Global). Compare entre bancos.",
      "**Transferir dinheiro por telemóvel**: qualquer método de transferência que não conhece (PayPal, Lydia, transferência bancária para desconhecido) — verifique antes de enviar.",
      "**Tutela financeira**: se tiver dificuldades crónicas, pode pedir restrição de gastos através da Commission de surendettement.",
    ],
    question: "Qual o documento necessário para receber ou enviar uma transferência bancária?",
    options: [
      { id: 'a', text: "RIB (que contém o IBAN)", correct: true },
      { id: 'b', text: "Apenas o número da conta", correct: false },
      { id: 'c', text: "O cartão bancário físico", correct: false },
    ],
    explication_reponse: "O RIB contém o IBAN, BIC e todos os dados necessários para a transferência. Obtenha-o na aplicação do banco em segundos e partilhe-o com segurança para receber pagamentos.",
  },
];
